var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9957 2C8.72641 2 2 8.7283 2 16.9999C2 20.2803 3.0579 23.3225 4.85625 25.7918L2.98724 31.3649L8.75278 29.5222C11.1241 31.0919 13.954 32 17.0043 32C25.2736 32 32 25.2715 32 17.0001C32 8.72856 25.2736 2.00025 17.0043 2.00025L16.9957 2ZM12.808 9.61927C12.5172 8.92267 12.2967 8.89629 11.8561 8.87838C11.7061 8.86967 11.5389 8.86096 11.3535 8.86096C10.7803 8.86096 10.1809 9.02845 9.8194 9.39878C9.37877 9.84849 8.28551 10.8977 8.28551 13.0495C8.28551 15.2013 9.85473 17.2823 10.0662 17.5735C10.2867 17.8642 13.1255 22.3439 17.5333 24.1697C20.9802 25.5982 22.0031 25.4658 22.7875 25.2983C23.9335 25.0514 25.3706 24.2045 25.7321 23.1819C26.0937 22.1588 26.0936 21.2857 25.9877 21.1006C25.8819 20.9154 25.5908 20.8099 25.1502 20.5891C24.7095 20.3686 22.5671 19.3104 22.1616 19.1693C21.7647 19.0195 21.3858 19.0725 21.0862 19.4958C20.663 20.0866 20.2488 20.6864 19.9136 21.0478C19.6491 21.33 19.217 21.3654 18.8557 21.2153C18.3708 21.0127 17.0133 20.5361 15.3381 19.0459C14.0421 17.8908 13.1606 16.4536 12.9051 16.0215C12.6493 15.5808 12.8787 15.3247 13.0812 15.0868C13.3016 14.8133 13.5131 14.6194 13.7336 14.3635C13.954 14.108 14.0774 13.9756 14.2185 13.6757C14.3685 13.3847 14.2625 13.0848 14.1568 12.8643C14.0511 12.6438 13.1695 10.4921 12.808 9.61927Z",
    fill: "#67C15E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.16de937d41e605498c85a1dee6b1ab43.svg";
export { ForwardRef as ReactComponent };